
 const initialState = {
  customerDetails:'' 
} 

export default function productListView( state = initialState, action) {
  console.log(action,"action.type====>productList",action.payload)
if(action.type==='Customer_Details'){
    return {
      ...state,
      customerDetails:action.payload,
    }
  }
  return state; 

}


